

































































































import { Component, Vue, Prop } from 'vue-property-decorator'

import LoadingPlaceholder from '@/components/LoadingPlaceholder.vue'

import Booking from '@/models/booking'

import dayjs from '@/dayjs'
import { compactDateFormat } from '@/globalFilters'

@Component({
  components: {
    LoadingPlaceholder,
  },
})
export default class BookingInfoCard extends Vue {
  @Prop() bookingLoaded!: boolean
  @Prop() booking!: Booking

  get departureDate() {
    return (
      this.booking && dayjs.utc(this.booking.departAt).format(compactDateFormat)
    )
  }

  get checkoutDate() {
    return (
      this.booking &&
      dayjs.utc(this.booking.checkoutDate).format(compactDateFormat)
    )
  }

  get departingIn(): string {
    if (!this.booking) {
      return ''
    }

    const departure = dayjs.utc(this.booking.departAt)

    if (departure.isSame(dayjs.utc(), 'day')) {
      return 'Today'
    } else if (departure.isSame(dayjs.utc().add(1, 'day'), 'day')) {
      return 'Tomorrow'
    }

    return departure.fromNow()
  }

  get transportIsAssigned(): boolean {
    return !!this.booking && !!this.booking.transportName
  }

  get transportName(): string {
    if (!this.booking) {
      return ''
    }

    if (this.transportIsAssigned) {
      return this.booking.transportName
    }

    return `Assigned ${dayjs.utc(this.booking.departAt).fromNow()}`
  }

  get background(): { backgroundImage: string } | null {
    if (!this.booking || !this.booking.productBackgroundImageUrl) {
      return null
    }
    return {
      backgroundImage: 'url(' + this.booking.productBackgroundImageUrl + ')',
    }
  }

  get loaderOptions() {
    if (window.innerWidth > 992) {
      return {
        width: 370,
        height: 560,
      }
    } else if (window.innerWidth > 400) {
      return {
        width: 370,
        height: 250,
      }
    } else {
      return {
        width: 280,
        height: 340,
      }
    }
  }
}
